import { SampleMaturityParams } from '@/backend/access/sampleMaturity/types';

export class SampleMaturity {
  id: string;
  name: string;
  description?: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  projectId: string;
  propelOrgId: string;

  get title(): string {
    return this.name;
  }

  constructor(params: SampleMaturityParams) {
    this.id = params.id;
    this.name = params.name;
    this.description = params.description;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.projectId = params.projectId;
    this.propelOrgId = params.propelOrgId;
  }
}
